import type { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'
import type { VoltageClass } from '@ebalance/proto/bffuser/v1/occto_master_model_pb'
import type { GetSplitSupplyContractFormOptionsResponse } from '@ebalance/proto/bffuser/v1/occto_master_service_pb'

/** 事業者の選択肢 1 件。 */
export type BusinessOption = {
  id: string
  code: string
  name: string
}

/** 供給地点の選択肢 1 件 (契約のない地点)。 */
export type SupplyPointOption = {
  supplyPointSpecificNumber: string
  customerName: string
  areaCode: AreaCode
  voltageClass: VoltageClass
}

/** 登録フォームの候補 (backend が決めたものをそのまま使う)。 */
export type SplitSupplyFormOptions = {
  supplyPoints: SupplyPointOption[]
  ownBusinesses: BusinessOption[]
  partnerBusinesses: BusinessOption[]
}

export const EMPTY_FORM_OPTIONS: SplitSupplyFormOptions = {
  supplyPoints: [],
  ownBusinesses: [],
  partnerBusinesses: [],
}

export function convertFormOptions(
  resp: GetSplitSupplyContractFormOptionsResponse,
): SplitSupplyFormOptions {
  const toBusiness = (b: {
    businessMasterId: string
    businessCode: string
    businessName: string
  }): BusinessOption => ({
    id: b.businessMasterId,
    code: b.businessCode,
    name: b.businessName,
  })
  return {
    supplyPoints: resp.supplyPoints.map((p) => ({
      supplyPointSpecificNumber: p.supplyPointSpecificNumber,
      customerName: p.customerName,
      areaCode: p.areaCode,
      voltageClass: p.voltageClass,
    })),
    ownBusinesses: resp.ownBusinesses.map(toBusiness),
    partnerBusinesses: resp.partnerBusinesses.map(toBusiness),
  }
}

/** 事業者の表示 ("1001: 〇〇電力")。 */
export function businessLabel(b: { code: string; name: string }): string {
  return b.name === '' ? b.code : `${b.code}: ${b.name}`
}
